import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Input, Spinner } from '../../components/ui.jsx';
import { AuthShell } from './LoginPage.jsx';
import { useAuthStore } from '../../store.js';
import { api } from '../../api.js';

export default function MagicLinkPage({ purpose }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const loadMe = useAuthStore(s => s.loadMe);
  const token = params.get('token');

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [needsPassword, setNeedsPassword] = useState(false);
  const [newPassword, setNewPassword] = useState('');

  useEffect(() => {
    if (!token) { setError('Missing token'); setLoading(false); return; }
    if (purpose === 'password_reset') { setLoading(false); setNeedsPassword(true); return; }
    (async () => {
      try {
        await api.magicLinkVerify({ token });
        await loadMe();
        navigate('/dashboard');
      } catch (err) {
        setError(err.message || 'Sign-in failed');
        setLoading(false);
      }
    })();
  }, [token, purpose, loadMe, navigate]);

  const submitPassword = async (e) => {
    e.preventDefault();
    setLoading(true); setError(null);
    try {
      await api.magicLinkVerify({ token, new_password: newPassword });
      await loadMe();
      navigate('/dashboard');
    } catch (err) { setError(err.message); setLoading(false); }
  };

  return (
    <AuthShell>
      {loading ? (
        <div className="text-center py-8"><Spinner className="w-8 h-8 text-primary-600" /></div>
      ) : needsPassword ? (
        <form onSubmit={submitPassword} className="space-y-4">
          <h1 className="text-xl font-semibold text-ink-900">Set a new password</h1>
          <Input label="New password" type="password" required value={newPassword} onChange={e => setNewPassword(e.target.value)} hint="12+ chars, mixed case, number, symbol" />
          {error ? <p className="text-sm text-danger">{error}</p> : null}
          <Button type="submit" className="w-full">Save and sign in</Button>
        </form>
      ) : error ? (
        <div className="text-center">
          <h1 className="text-xl font-semibold text-ink-900">Sign-in failed</h1>
          <p className="text-sm text-danger mt-2">{error}</p>
        </div>
      ) : null}
    </AuthShell>
  );
}
